export const body = {
    // paddingTop: "85px",
    // backgroundColor: "#FAF3F3",
    minHeight: "50vh"
};

export const errorMessage = {
    textAlign: "center"
};
